import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_EE.json';
import exercises from './PILATES_EXERCISES_EE.json';
import recipes from './PILATES_RECIPES_EE.json';

export const PILATES_DATA_EE: ServiceData = {
  articles,
  exercises,
  recipes,
};
